import React, { useState } from "react";

import { db } from "../../modules/auth/firebaseConfig";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import SeoMeta from "../SEO/SeoMeta";
import { Helmet } from "react-helmet-async";
import M2TLogo from "./M2TLogo";
//import FooterLinks from "../LandingPage/FooterLinks";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

function M2THeader() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 flex items-center gap-3 bg-[#0B0F19] px-6 py-5 shadow-md">
      <div
        className="flex cursor-pointer items-center gap-2"
        onClick={() => navigate("/")}
        aria-label="Go to homepage"
      >
        <M2TLogo className="h-[1.8rem] sm:h-[2.3rem] md:h-[2.8rem]" />
        {/* <div className="hidden sm:block leading-tight text-left">
                    <div className="font-semibold text-lg md:text-2xl text-black">Million2Trillion</div>
                    <div className="text-[9px] md:text-xs tracking-wide text-gray-500">
                        Professional <span className="text-black/80">Market Network</span>
                    </div>
                </div> */}
      </div>
    </header>
  );
}

export default function PartnerSignup() {
  const [form, setForm] = useState({
    fullName: "",
    companyName: "",
    email: "",
    phone: "",
    country: "",
    website: "",
    businessType: "",
    description: "",
    // collaboration: "",
    // expectation: "",
    // logo: null,
    agree: false,
    trap: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const onChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "file") {
      setForm((f) => ({ ...f, [name]: files[0] }));
    } else {
      setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
    }
  };

  // --------------------------
  // VALIDATION HELPERS
  // --------------------------

  const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const isValidWebsite = (url) => {
    try {
      const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;
      return pattern.test(url.trim());
    } catch {
      return false;
    }
  };

  const isValidPhone = (phone) => {
    const phoneClean = phone.replace(/[^0-9]/g, "");
    return phoneClean.length >= 6 && phoneClean.length <= 15;
  };

  const isRealText = (str) => {
    return str.trim().length > 2 && /[A-Za-z]/.test(str);
  };

  const containsForbiddenWords = (str) => {
    const badWords = [
      "test",
      "fake",
      "aaaa",
      "admin",
      "null",
      "undefined",
      "spam",
    ];
    return badWords.some((w) => str.toLowerCase().includes(w));
  };

  const submit = async (e) => {
    e.preventDefault();

    if (form.trap) return;
    if (!form.agree)
      return alert("Please agree to the terms before submitting.");

    // Validation
    if (!isRealText(form.fullName))
      return alert("Please enter a valid full name.");
    if (containsForbiddenWords(form.fullName)) return alert("Invalid name.");

    if (!isRealText(form.companyName))
      return alert("Please enter a valid company name.");
    if (containsForbiddenWords(form.companyName))
      return alert("Company name appears invalid.");

    if (!isValidEmail(form.email))
      return alert("Please enter a valid email address.");
    if (!isValidWebsite(form.website)) return alert("Invalid website URL.");

    if (form.phone && !isValidPhone(form.phone))
      return alert("Invalid phone number.");

    if (!isRealText(form.description))
      return alert("Please enter a proper business description.");

    try {
      const email = form.email.trim().toLowerCase();

      // FINAL WRITE — shorter data structure
      await setDoc(
        doc(db, "partners_waitlist", email),
        {
          fullName: form.fullName.trim(),
          companyName: form.companyName.trim(),
          email,
          phone: form.phone.trim(),
          country: form.country,
          website: form.website.trim(),
          businessType: form.businessType,
          description: form.description.trim(),
          createdAt: serverTimestamp(),
          status: "pending",
          verified: false,
        },
        { merge: false },
      );

      setSubmitted(true);
    } catch (err) {
      console.error("Partner submit error:", err);

      if (err.code === "permission-denied") {
        alert("This email is already registered.");
      } else {
        alert("Submission failed. Please try again.");
      }
    }
  };

  if (submitted) {
    return (
      <>
        <SeoMeta
          title="Become a Partner — Million2Trillion Global Ecosystem"
          description="Apply to become an official Million2Trillion partner. Brokers, platforms, prop firms, educators, media companies, charting tools, fintechs, and more."
          url="https://million2trillion.com/partner"
        />
        <Helmet>
          <title>Thanks — M2T Partner Registration Received</title>
        </Helmet>
        <M2THeader />
        <div className="flex min-h-screen items-center justify-center bg-[#0B0F19] px-4 text-black">
          <div className="mx-auto w-full max-w-3xl rounded-lg border border-gray-200 bg-white p-8 text-center shadow-xl">
            <h1 className="mb-2 text-3xl font-bold text-blue-600">
              Thank You for Your Interest 🎉
            </h1>
            <p className="text-sm leading-relaxed text-gray-700">
              Your partnership application has been received.
              <br />
              Our core team will review your details and contact you soon.
              <br />
              <br />
              Thank you for your interest in collaborating with
              Million2Trillion.
            </p>

            <Link
              to="/"
              className="mt-6 inline-block rounded-lg bg-blue-600 px-6 py-3 font-semibold text-white hover:bg-blue-700"
            >
              Back to Home
            </Link>
          </div>
        </div>
        {/* <FooterLinks /> */}
      </>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-[#0B0F19]">
      <SeoMeta
        title="Become a Partner — Million2Trillion Global Market Ecosystem"
        description="Apply to collaborate with Million2Trillion. Ideal for brokers, prop firms, academies, fintechs, advisors, media, platforms, and institutions."
        url="https://million2trillion.com/partner"
      />
      <M2THeader />
      <div className="py-12">
        <div className="mx-auto w-full max-w-3xl rounded-2xl border border-white/10 bg-white/5 p-16">
          <h1 className="mb-2 text-center text-3xl font-bold text-blue-400">
            Become an M2T Partner
          </h1>
          <p className="mb-6 text-center text-sm text-gray-400">
            Collaborate with the world’s first verified financial market
            ecosystem.
          </p>

          <form onSubmit={submit} className="space-y-3">
            <input
              name="fullName"
              required
              placeholder="Full Name"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />

            <input
              name="companyName"
              required
              placeholder="Company Name"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />

            <input
              type="email"
              name="email"
              required
              placeholder="Email Address"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />

            <input
              name="phone"
              placeholder="Phone Number"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />

            <select
              name="country"
              value={form.country}
              onChange={onChange}
              required
              className="w-full rounded border border-gray-600 bg-gray-800 p-3 text-white"
            >
              <option value="">Select Country</option>
              {/* East Asia */}
              <optgroup label="East Asia">
                <option>China</option>
                <option>Japan</option>
                <option>South Korea</option>
                <option>North Korea</option>
                <option>Mongolia</option>
                <option>Taiwan</option>
                <option>Hong Kong</option>
                <option>Macau</option>
              </optgroup>
              {/* Southeast Asia */}
              <optgroup label="Southeast Asia">
                <option>Brunei</option>
                <option>Cambodia</option>
                <option>Indonesia</option>
                <option>Laos</option>
                <option>Malaysia</option>
                <option>Myanmar</option>
                <option>Philippines</option>
                <option>Singapore</option>
                <option>Thailand</option>
                <option>Timor-Leste</option>
                <option>Vietnam</option>
              </optgroup>
              {/* South Asia */}
              <optgroup label="South Asia">
                <option>Afghanistan</option>
                <option>Bangladesh</option>
                <option>Bhutan</option>
                <option>India</option>
                <option>Maldives</option>
                <option>Nepal</option>
                <option>Pakistan</option>
                <option>Sri Lanka</option>
              </optgroup>
              {/* Central Asia */}
              <optgroup label="Central Asia">
                <option>Kazakhstan</option>
                <option>Kyrgyzstan</option>
                <option>Tajikistan</option>
                <option>Turkmenistan</option>
                <option>Uzbekistan</option>
              </optgroup>
              {/* Western Asia / Middle East */}
              <optgroup label="Middle East / Western Asia">
                <option>Armenia</option>
                <option>Azerbaijan</option>
                <option>Bahrain</option>
                <option>Cyprus</option>
                <option>Georgia</option>
                <option>Iran</option>
                <option>Iraq</option>
                <option>Israel</option>
                <option>Jordan</option>
                <option>Kuwait</option>
                <option>Lebanon</option>
                <option>Oman</option>
                <option>Palestine</option>
                <option>Qatar</option>
                <option>Saudi Arabia</option>
                <option>Syria</option>
                <option>Turkey</option>
                <option>United Arab Emirates</option>
                <option>Yemen</option>
              </optgroup>
              {/* North America */}
              <optgroup label="North America">
                <option>United States</option>
                <option>Canada</option>
                <option>Mexico</option>
                <option>Bahamas</option>
                <option>Panama</option>
                <option>Barbados</option>
              </optgroup>
              {/* Central America */}
              <optgroup label="Central America">
                <option>Belize</option>
                <option>Costa Rica</option>
                <option>El Salvador</option>
                <option>Guatemala</option>
                <option>Honduras</option>
                <option>Nicaragua</option>
              </optgroup>
              {/* Caribbean */}
              <optgroup label="Caribbean">
                <option>Cuba</option>
                <option>Dominican Republic</option>
                <option>Haiti</option>
                <option>Jamaica</option>
                <option>Trinidad and Tobago</option>
                <option>Saint Lucia</option>
                <option>Grenada</option>
              </optgroup>
              {/* South America */}
              <optgroup label="South America">
                <option>Argentina</option>
                <option>Bolivia</option>
                <option>Brazil</option>
                <option>Chile</option>
                <option>Colombia</option>
                <option>Ecuador</option>
                <option>Guyana</option>
                <option>Paraguay</option>
                <option>Peru</option>
                <option>Suriname</option>
                <option>Uruguay</option>
                <option>Venezuela</option>
              </optgroup>
              {/* Europe */}
              <optgroup label="Europe">
                <option>Albania</option>
                <option>Andorra</option>
                <option>Austria</option>
                <option>Belarus</option>
                <option>Belgium</option>
                <option>Bosnia and Herzegovina</option>
                <option>Bulgaria</option>
                <option>Croatia</option>
                <option>Czech Republic</option>
                <option>Denmark</option>
                <option>Estonia</option>
                <option>Finland</option>
                <option>France</option>
                <option>Germany</option>
                <option>Greece</option>
                <option>Hungary</option>
                <option>Ireland</option>
                <option>Italy</option>
                <option>Latvia</option>
                <option>Iceland</option>
                <option>Kosovo</option>
                <option>Liechtenstein</option>
                <option>Lithuania</option>
                <option>Luxembourg</option>
                <option>Malta</option>
                <option>Montenegro</option>
                <option>Netherlands</option>
                <option>North Macedonia</option>
                <option>Norway</option>
                <option>Poland</option>
                <option>Portugal</option>
                <option>Romania</option>
                <option>Russia</option>
                <option>Slovakia</option>
                <option>Slovenia</option>
                <option>Spain</option>
                <option>Sweden</option>
                <option>Switzerland</option>
                <option>Ukraine</option>
                <option>United Kingdom</option>
              </optgroup>
              {/* Oceania */}
              <optgroup label="Oceania">
                <option>Australia</option>
                <option>New Zealand</option>
                <option>Fiji</option>
                <option>Papua New Guinea</option>
                <option>Samoa</option>
                <option>Vanuatu</option>
                <option>Tonga</option>
                <option>Solomon Islands</option>
              </optgroup>
              {/* Africa */}
              <optgroup label="Africa">
                <option>Nigeria</option>
                <option>South Africa</option>
                <option>Egypt</option>
                <option>Kenya</option>
                <option>Morocco</option>
                <option>Ghana</option>
                <option>Rwanda</option>
                <option>Tanzania</option>
                <option>Uganda</option>
                <option>Zambia</option>
                <option>Gabon</option>
                <option>Gambia</option>
                <option>Guinea</option>
                <option>Guinea-Bissau</option>
                <option>Ivory Coast</option>
                <option>Lesotho</option>
                <option>Liberia</option>
                <option>Libya</option>
                <option>Niger</option>
                <option>São Tomé and Príncipe</option>
                <option>Senegal</option>
                <option>Seychelles</option>
                <option>Sierra Leone</option>
                <option>Somalia</option>
                <option>South Sudan</option>
                <option>Sudan</option>
                <option>Swaziland (Eswatini)</option>
                <option>Togo</option>
                <option>Tunisia</option>
                <option>Western Sahara</option>
                <option>Zimbabwe</option>
              </optgroup>
              {/* Fallback */}
              <option>Others</option>
            </select>

            {form.country === "Others" && (
              <input
                name="countryOther"
                placeholder="Enter your country"
                required
                className="w-full rounded border border-gray-600 bg-gray-800 p-3"
                onChange={onChange}
              />
            )}

            <input
              name="website"
              required
              placeholder="Company Website"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />

            <select
              name="businessType"
              required
              className="w-full rounded border border-gray-600 bg-gray-800 p-3 text-white"
              onChange={onChange}
            >
              <option value="">Select Business Type</option>
              <option>Broker / Brokerage</option>
              <option>Prop Firm</option>
              <option>Academy / Training</option>
              <option>Charting Platform</option>
              <option>Fintech Tool</option>
              <option>Media / Influencer / Creator</option>
              <option>Advisory / Consultancy</option>
              <option>Fund / Investment Group</option>
              <option>Tech Provider</option>
              <option>Others</option>
            </select>

            <textarea
              name="description"
              rows={3}
              required
              placeholder="Describe your business"
              className="w-full rounded border border-gray-600 bg-gray-800 p-3"
              onChange={onChange}
            />

            {/* <textarea
                        name="collaboration"
                        rows={3}
                        placeholder="How do you want to collaborate with Million2Trillion?"
                        className="w-full p-3 rounded bg-gray-800 border border-gray-600"
                        onChange={onChange}
                    /> */}

            {/* <textarea
                        name="expectation"
                        rows={3}
                        placeholder="What do you expect from Million2Trillion?"
                        className="w-full p-3 rounded bg-gray-800 border border-gray-600"
                        onChange={onChange}
                    /> */}

            {/* <label className="w-full flex items-center justify-center p-3 bg-gray-800 border border-gray-600 rounded cursor-pointer hover:bg-gray-700 text-white">
                        {form.logo ? form.logo.name : "Upload Company Logo (optional)"}
                        <input type="file" name="logo" accept="image/*" onChange={onChange} className="hidden" />
                    </label> */}

            <input name="trap" className="hidden" onChange={onChange} />

            <label className="flex items-start gap-2 text-sm text-gray-300">
              <input
                type="checkbox"
                name="agree"
                checked={form.agree}
                onChange={onChange}
                className="mt-1"
              />
              <span>I agree to be contacted by Million2Trillion.</span>
            </label>

            <button
              type="submit"
              className="w-full rounded bg-blue-600 py-3 font-semibold text-white hover:bg-blue-700"
            >
              Submit Application
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link
              to="/"
              className="text-blue-400 underline hover:text-blue-300"
            >
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
      {/* <FooterLinks /> */}
    </div>
  );
}
